export const iosAppURL = "https://apps.apple.com/us/app/r24/id1564068630?itsct=apps_box_badge&amp;itscg=30200";
export const androidAppURL = "https://play.google.com/store/apps/details?id=com.rabbi24.r24daily";